__turbopack_context__.v({
  "root": "UserIconStatic-module__enfgya__root",
});
